import * as React from 'react'
import styled, { css } from "styled-components";
import Icon, { IconTypes } from '../Icons/Icon';
import { Style } from '../../styles';

const ToggleIcon = styled.div`
  width: 16px;
  height: 16px;

  svg {
    width: 14px;
    height: 14px;
  }
`

const Container = styled.div<{ open: boolean }>`
	display: flex;
	flex-direction: column;
	padding: 8px 24px;

  &:not(:last-child) {
    border-bottom: 1px solid ${Style.color.border};
  }

  ${props => !props.open && css`
    ${ToggleIcon} {
      transform: rotate(180deg);
    }
  `}

`

const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 12px 0;
  cursor: pointer;
`

const HeaderDetails = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  font-size: 14px; 
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;

  svg {
    width: 16px;
    height: 16px;
  }
`

interface IProps {
  icon?: IconTypes
  title?: string
  children?: React.ReactNode
}

const DetailsSection = (props: IProps) => {
  const { children, icon, title } = props
  const [open, setOpen] = React.useState(true)

  return (
    <Container open={open}>
      {(title || icon) && <Header onClick={() => setOpen(!open)}>
        <HeaderDetails>
          {icon && <Icon icon={icon} />}
          {title}
        </HeaderDetails>
        <ToggleIcon>
          <Icon icon='chevron-down' />
        </ToggleIcon>
      </Header>}
      {open && children}
    </Container>
  )
}

export default DetailsSection